<template>
  <div class="user">
    <div class="userManage_header">
      <div class="userManage_logo">
        <img src="@/assets/imgs/icon/feedback_logo.png" alt />
      </div>
      <h3>问题反馈</h3>
    </div>
    <div class="userManage_add_user">
      <el-button
        type="primary"
        size="small"
        @click="feedbackDialogVisible()"
        class="bg5584FF"
      >
        <i class="el-icon-plus"></i>反馈
      </el-button>
    </div>
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
      v-loading="loading"
    >
      <el-table-column
        align="center"
        type="index"
        width="100"
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span class="detail" @click="handleDetail(scope.row)">{{
            scope.row.title
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="description"
        label="问题描述"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="feedBackTime"
        label="反馈时间"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作详情" align="center">
        <template slot-scope="scope">
          <el-button
            v-show="scope.row.status == 0"
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="handleManage(scope.row)"
            >查看回复</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pageBox">
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page.sync="currentPage"
        :page-size="10"
        layout="prev, pager, next, jumper"
        :total="total"
      ></el-pagination> -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="10"
        layout="total,  prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 新增反馈 -->
    <el-dialog
      title="新增反馈"
      :visible.sync="addDialogVisible"
      width="770px"
      class="titleChange"
      :close-on-click-modal="false"
      @closed="addHandleClose"
    >
      <div class="addUser">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="135px"
          class="demo-ruleForm"
          size="small"
        >
          <el-form-item label="标题：" prop="title">
            <el-input
              v-model.trim="ruleForm.title"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="附件：">
            <el-upload
              class="upload-demo"
              :action="`${fileBaseUrl}/system/file/upload`"
              :on-success="handleSuccess"
              :on-error="handleError"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :limit="3"
              :on-exceed="handleExceed"
              :file-list="fileList"
              multiple
            >
              <el-button size="small" type="primary">
                <i class="el-icon-upload"></i>上传附件
              </el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="问题描述：" prop="description">
            <el-input
              type="textarea"
              v-model.trim="ruleForm.description"
              placeholder="请在200字以内进行描述"
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈用户：">
            <el-input
              v-model.trim="ruleForm.userName"
              placeholder="请输入用户名"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式：" prop="telephone">
            <el-input
              v-model.trim="ruleForm.telephone"
              placeholder="请输入联系方式"
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈时间：">
            <el-input
              v-model.trim="ruleForm.feedBackTime"
              placeholder
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="单位/企业：">
            <el-input
              v-model.trim="ruleForm.department"
              placeholder="请输入单位/企业"
              disabled
            ></el-input>
          </el-form-item>
          <div class="btnBox">
            <el-button type="primary" @click="submitForm('ruleForm')"
              >提交</el-button
            >
            <el-button @click="addDialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 查看回复 -->
    <el-dialog
      title="查看回复"
      :visible.sync="viewReplyDialogVisible"
      width="770px"
      class="titleChange dialog771 bodyScroll"
      @closed="handleClose"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          :model="viewReply"
          label-width="135px"
          class="demo-ruleForm inputBorderNone"
          size="small"
        >
          <el-form-item label="标题：" prop="title">
            <el-input v-model="viewReply.title" disabled></el-input>
          </el-form-item>
          <el-form-item label="附件：">
            <ul style="padding: 0; margin: 0">
              <li v-for="item in filesList" :key="item.fileId">
                <!-- <span style="margin-left:14px">{{item.fileName}}</span> -->
                <a
                  :href="`${fileBaseUrl}/system/file/download/${item.fileId}`"
                  >{{ item.fileName }}</a
                >
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="问题描述：" prop="description">
            <el-input
              type="textarea"
              v-model="viewReply.description"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈用户：">
            <el-input v-model="viewReply.userName" disabled></el-input>
          </el-form-item>
          <el-form-item label="联系方式：">
            <el-input
              v-model="viewReply.telephone"
              disabled
              placeholder="暂无联系方式"
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈时间：">
            <el-input v-model="viewReply.feedBackTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="单位/企业：">
            <el-input v-model="viewReply.department" disabled></el-input>
          </el-form-item>
        </el-form>
        <div class="viewReply">
          <ul>
            <li>
              <p>
                <span>回复人：</span>
                <span>{{ viewReplyList.replyUser }}</span>
              </p>
              <p>
                <span>回复时间：</span>
                <span>{{ viewReplyList.replyTime }}</span>
              </p>
            </li>
            <li>
              <p>
                <span>回复内容：</span>
                <el-input
                  disabled
                  class="inputBorderNone"
                  type="textarea"
                  v-model="viewReplyList.replyContent"
                ></el-input>
              </p>
            </li>
            <li>
              <p>
                <span>回复附件：</span>
                <a
                  :href="`${fileBaseUrl}/system/file/download/${item.fileId}`"
                  v-for="item in viewFilesList"
                  :key="item.feedBackId"
                  style="dispaly: inline-block; margin-right: 5px"
                  >{{ item.fileName }}</a
                >
              </p>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
    <!-- 查看问题 -->
    <el-dialog
      title="查看问题"
      :visible.sync="viewProblemsDialogVisible"
      width="770px"
      class="titleChange"
      @closed="handleClose"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          :model="viewReply"
          label-width="135px"
          class="demo-ruleForm inputBorderNone"
          size="small"
        >
          <el-form-item label="标题：" prop="title">
            <el-input v-model="viewReply.title" disabled></el-input>
          </el-form-item>
          <el-form-item label="附件：">
            <ul style="padding: 0; margin: 0">
              <li v-for="item in filesList" :key="item.fileId">
                <!-- <span style="margin-left:14px">{{item.fileName}}</span> -->
                <a
                  :href="`${fileBaseUrl}/system/file/download/${item.fileId}`"
                  >{{ item.fileName }}</a
                >
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="问题描述：" prop="description">
            <el-input
              type="textarea"
              v-model="viewReply.description"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈用户：">
            <el-input v-model="viewReply.userName" disabled></el-input>
          </el-form-item>
          <el-form-item label="联系方式：" prop="telephone">
            <el-input
              v-model="viewReply.telephone"
              placeholder="暂无联系方式"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈时间：">
            <el-input v-model="viewReply.feedBackTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="单位/企业：">
            <el-input v-model="viewReply.department" disabled></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  name: "User",
  data() {
    // 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (!value) {
        // callback();
        return callback(new Error("电话号码不能为空")); // 必填验证  此处非必填
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("电话号码格式不正确"));
          }
        }
      }, 100);
    };
    var checkLength = (rule, value, callback) => {
      if (!value) {
        // callback();
        return callback(new Error("问题描述不能为空")); //必填验证
      }
      if (value.length > 200) {
        callback(
          new Error("输入长度限制为200字符，当前输入长度" + value.length)
        );
      } else {
        callback();
      }
    };
    return {
      addDialogVisible: false,
      viewReplyDialogVisible: false,
      viewProblemsDialogVisible: false,
      labelPosition: "left",
      currentPage: 1,
      feedBackDescription: "",
      total: 0,
      pageNum: 1,
      userName: "",
      loading: false,
      tableData: [],
      fileList: [], //上传文件列表
      filesList: [], //查看上传文件列表
      viewFilesList: [], //回复文件列表
      viewReplyList: [],

      fileBaseUrl: this.$GLOBAl.fileBaseUrl,
      ruleForm: {
        //提交表单
        title: "",
        files: [],
        description: "",
        userName: "",
        telephone: "",
        feedBackTime: "",
        department: "",
      },
      viewReply: {
        //回复表单
        title: "",
        files: "",
        description: "",
        userName: "",
        telephone: "",
        feedBackTime: "",
        department: "",
      },
      rules: {
        //表单验证规则
        title: [{ required: true, message: "请输入用户名称", trigger: "blur" }],
        description: [
          { required: true, validator: checkLength, trigger: "blur" },
        ],
        telephone: [{ required: true, validator: checkPhone, trigger: "blur" }],
      },
    };
  },
  created() {
    this.getData(this.pageNum);
    this.userName = sessionStorage.getItem("loginName");
    this.ruleForm.userName = sessionStorage.getItem("name");
  },
  methods: {
    getData(pageNum) {
      this.loading = true;
      this.$axios
        .get("/system/feedback/selectByUserName", {
          params: {
            pageNum,
            pageSize: 10,
            userName: sessionStorage.getItem("loginName"),
          },
        })
        .then((res) => {
          this.loading = false;
          console.log(res);
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleClose() {
      this.filesList = [];
      this.viewReplyList = [];
      this.viewFilesList = [];
    },
    feedbackDialogVisible() {
      this.addDialogVisible = true;
      // this.ruleForm.userName = sessionStorage.getItem("loginName");
      this.ruleForm.userName = sessionStorage.getItem("name");
      this.ruleForm.department = sessionStorage.getItem("department");
      this.ruleForm.feedBackTime = this.$moment(new Date()).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    handleDetail(row) {
      this.viewProblemsDialogVisible = true;
      this.$axios
        .get(`/system/feedback/selectFeedBackDetail/${row.id}`)
        .then((res) => {
          JSON.parse(res.data.files).forEach((item) => {
            this.filesList.push(JSON.parse(item));
          });
          this.viewReply = res.data;
        });
    },
    handleManage(row) {
      //查看回复
      this.viewReplyDialogVisible = true;
      this.$axios
        .get(`/system/feedback/selectFeedBackDetail/${row.id}`)
        .then((res) => {
          JSON.parse(res.data.files).forEach((item) => {
            this.filesList.push(JSON.parse(item));
          });
          this.viewReply = res.data;
        });
      this.$axios
        .get(`/system/reply/selectByPrimaryKey/${row.replyId}`)
        .then((res) => {
          this.viewReplyList = res.data;
          this.viewFilesList = JSON.parse(res.data.replyFiles);
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      //跳转页
      console.log(`当前页: ${val}`);
      this.getData(val);
    },
    submitForm(formName) {
      //新增提交

      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm);
          this.ruleForm.files = JSON.stringify(this.ruleForm.files);
          this.$axios
            .post("/system/feedback/insertFeedBackInfo", this.ruleForm)
            .then((res) => {
              if (res.status == 0) {
                Message.success("新增成功");
                this.addDialogVisible = false;
                this.fileList = [];
                this.getData(this.pageNum);
                for (let key in this.ruleForm) {
                  if (key == "files") {
                    this.ruleForm[key] = [];
                  } else {
                    this.ruleForm[key] = "";
                  }
                }
              }
            });
        } else {
          // Message.error("请完善表单信息");
          return false;
        }
      });
    },
    handleSuccess(response, file, fileList) {
      //上传成功
      Message.success("上传成功");
      console.log(response, file, fileList);
      this.ruleForm.files.push(response.data);
    },
    handleError(err, file, fileList) {
      //上传失败
      console.log(err, file, fileList);
      Message.error("上传失败");
    },
    handleRemove(file, fileList) {
      // 文件列表移除
      console.log(file, fileList);
      this.ruleForm.files = this.ruleForm.files.filter((item) => {
        return item != file.response.data;
      });
    },
    handlePreview(file) {
      // 点击文件列表中已上传的文件时的钩子
      console.log(file);
    },
    handleExceed(files, fileList) {
      // 文件超出个数限制时的钩子
      console.log(files);
      console.log(fileList);
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    addHandleClose() {
      this.ruleForm.files = [];
      this.fileList = [];
      this.$refs.ruleForm.resetFields();
    },
    beforeRemove(file) {
      // 删除文件之前的钩子

      return this.$confirm(`确定移除 ${file.name}？`).then(() => {
        // console.log(file)
        // this.$axios.get(`/file/delete/${file.response.data}`)
      });
    },
    downLoad(id) {
      console.log(id);
      this.$axios.get(`/system/file/download/${id}`).then(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.userManage_header {
  height: 61px;
  width: 100%;
  display: flex;
  margin-bottom: 29px;
  border-bottom: 1px solid rgba(155, 155, 155, 0.25);
  margin-bottom: 20px;
  .userManage_logo {
    margin: 2px 20px 0 2px;
  }
  h3 {
    font-size: 24px;
    height: 100%;
    margin: 0;
    color: #444444;
  }
}
.userManage_add_user {
  margin-bottom: 20px;
}
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
.viewReply {
  width: 100%;
  min-height: 200px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 9px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  padding: 5% 8%;
  ul {
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
    height: 100%;
    li {
      width: 100%;
      height: 33.33%;
      p {
        display: inline-block;
        width: 100%;
        span {
          display: inline-block;
        }
      }
    }
    li:nth-child(1) {
      p {
        width: 50%;
      }
    }
    li:nth-child(2) {
      p {
        display: flex;
        span {
          width: 84px;
        }
      }
    }
  }
}
</style>